import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { CATEGORIES } from '../../../Utilities/APIs'
import useFetch from '../../../Utilities/Hooks/useFetch'
import Image from '../../Partials/Elements/Image/Image'

import './Categories.css'

function Categories() {
  const [categories, loading] = useFetch(CATEGORIES, 'true')
  const { consumer } = useSelector(state => state.auth)

  return (
    <section className='categories_page page_padding ss_page'>
      <div className="container">
        <div className="ph_wrapper">
          {
            consumer
              ?
              consumer.language === 'english'
                ?
                <h2 className='page_heading'>What is the Topic you are searching for?</h2>
                :
                <h2 className='page_heading'>আপনি কি বিষয়ে তথ্য খোঁজ করতে চাচ্ছেন?</h2>
              :
              <h2 className='page_heading'>আপনি কি বিষয়ে তথ্য খোঁজ করতে চাচ্ছেন?</h2>
          }
        </div>

        <div className="row categories">
          {categories?.map((data) => (
            <div className="col" key={data._id}>
              <Link to={`/subcategory/${data._id}`}>
                <div className="category">
                  <div className="category_content">
                    <div className="category_img">
                      <Image imgSrc={data.image} imgAlt={data.name} />
                    </div>
                    <div className="category_title">
                      {
                        consumer
                          ?
                          consumer.language === 'english'
                            ?
                            <h3>{data.engName}</h3>
                            :
                            <h3>{data.name}</h3>
                          :
                          <h3>{data.name}</h3>
                      }
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
          {loading ? '...loading' : ''}
        </div>
      </div>
    </section>
  )
}

export default Categories